<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-5">
                  <h4 class="mb-4">Login</h4>
                  <p>{{ welcomeCaption }}</p>
                </div>
                <vs-input
                  autocomplete="off"
                  onClick="this.select();"
                  @click="stopLoading"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                />

                <vs-input
                  autocomplete="off"
                  onClick="this.select();"
                  @click="stopLoading"
                  type="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label="Password"
                  v-model="password"
                  class="w-full mt-2 no-icon-border"
                />

                <!-- <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                  <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                </div> -->
                <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
                <div class="pb-10 pt-6">
                  <vs-button ref="login" class="float-right vs-con-loading__container" :disabled="!(email && password)" @click="login">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundLoading: "#fff",
      email: "",
      password: "",
      checkbox_remember_me: false,
      welcomeCaption: ""
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    }
  },
  mounted() {
    var self = this;
    localStorage.clear();
    // sessionStorage.clear();
    localStorage.setItem("isStudent", "false");
    localStorage.setItem('type', 'other');
    self.setCaption();
    localStorage.setItem('Current_User_Id', '');
    window.addEventListener("keyup", self.eventListenerFunc, false);
    this.$setColors();
  },
  methods: {
    eventListenerFunc(event) {
      var self = this;
      if (event.keyCode === 13 && self.email && self.password)
        self.login();
    },
    stopLoading() {
      this.$vs.loading.close(this.$refs.login.$el);
    },
    setCaption(){
      if(localStorage.getItem('currentModule'))
        this.welcomeCaption = "Welcome back, please login to your account.";
      else
        this.welcomeCaption = "Welcome, please login to your account.";
    },
    login() {
      localStorage.setItem('userInfo', '');
      this.showLoadingOnButton();
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        },
        notify: this.$vs.notify,
        self: this
      };
      this.$vs.loading.close(this.$refs.login.$el);
      window.removeEventListener("keyup", this.eventListenerFunc, false);
      this.$store.dispatch("auth/adminLoginAttempt", payload);
    },
    notifyAlreadyLogedIn() {
      this.stopLoading();
      this.$vs.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    },
    showLoadingOnButton() {
      var self = this;
      self.$vs.loading({
        type: "material",
        container: self.$refs.login.$el,
        scale: 0.45
      });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #db4437;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
